import { Inject, Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, mergeMap, switchMap, tap } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MarketedPropertiesService } from 'src/app/core/services/marketed-properties/marketed-properties.service';
import {
  approveMarketedProperty,
  approveMarketedPropertyFailure,
  approveMarketedPropertySuccess,
  getMarketedProperties,
  getMarketedPropertiesFailure,
  getMarketedPropertiesSuccess,
  rejectMarketedProperty,
  rejectMarketedPropertyFailure,
  rejectMarketedPropertySuccess,
} from './marketed-properties.action';
import { setSharedData } from '../Authentication/authentication.actions';
import { CustomSnackbarComponent } from 'src/app/shared/custom-snackbar/custom-snackbar.component';

@Injectable()
export class MarketedPropertiesEffects {
  constructor(
    private actions$: Actions,
    @Inject(MarketedPropertiesService)
    private marketedPropertiesService: MarketedPropertiesService,
    private snackBar: MatSnackBar,
  ) {}

  getMarketedPropertiesEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getMarketedProperties),
      switchMap((action) =>
        this.marketedPropertiesService.getMarketedProperties(action.data).pipe(
          mergeMap((res) => [
            getMarketedPropertiesSuccess({ data: res }),
            setSharedData({ data: res }),
          ]),
          catchError((error) => {
            return of(getMarketedPropertiesFailure({ error }));
          }),
        ),
      ),
    );
  });

  approveMarketedPropertyEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(approveMarketedProperty),
      switchMap((action) =>
        this.marketedPropertiesService
          .approveMarketedProperty(action.id, action.comments)
          .pipe(
            tap(() => {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: 'Listing approved successfully.',
                  type: 'success',
                },
                panelClass: 'success',
                duration: 3000,
                horizontalPosition: 'right',
              });
            }),
            mergeMap((res) => [
              approveMarketedPropertySuccess({ data: res }),
              getMarketedProperties({ data: action.data }),
            ]),
            catchError((error) => {
              return of(approveMarketedPropertyFailure({ error }));
            }),
          ),
      ),
    );
  });

  rejectMarketedPropertyEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(rejectMarketedProperty),
      switchMap((action) =>
        this.marketedPropertiesService
          .rejectMarketedProperty(action.id, action.rejectionReason)
          .pipe(
            tap(() => {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: 'Listing rejected successfully.',
                  type: 'success',
                },
                panelClass: 'success',
                duration: 3000,
                horizontalPosition: 'right',
              });
            }),
            mergeMap((res) => [
              rejectMarketedPropertySuccess({ data: res }),
              getMarketedProperties({ data: action.data }),
            ]),
            catchError((error) => {
              return of(rejectMarketedPropertyFailure({ error }));
            }),
          ),
      ),
    );
  });
}
